export const toValuesArray = (tagsObjArr, key) =>
  tagsObjArr.map(tag => tag[key])

export const toObjectsArray = (tagsValArr, tagsObjArr, key) =>
  tagsValArr
    .map(val => tagsObjArr.find(tag => tag[key] === val))
    .filter(tag => tag !== null)
